// 导入axios
import axios from 'axios'
import * as api from './api.js'
import Qs from 'qs'
var request = axios.create({
    baseURL: api.basicUrl, // 协议地址
    type:'POST',
    timeout: 60000,
    headers: {
        'Content-Type': 'application/x-www-form-urlencoded',
    },
    transformRequest: [data => Qs.stringify(data, { indices: true })] //Qs.stringify将参数序列化成key=value&key=value的形式，indices: true是配置参数有传数组的时候，以下标的形式
})
/**设置post的请求头为application/x-www-form-urlencoded;charset=UTF-8 */
request.defaults.headers.post['Content-Type'] = 'application/x-www-form-urlencoded';
// 添加请求拦截器
request.interceptors.request.use(function (config) {
    // 在发送请求之前做些什么
    return config;
}, function (error) {
    // 对请求错误做些什么
    return Promise.reject(error);
});

// 添加响应拦截器
request.interceptors.response.use(function (response) {
    // 2xx 范围内的状态码都会触发该函数。
    // 对响应数据做点什么
    return response.data ? response.data : response;
}, function (error) {
    // 超出 2xx 范围的状态码都会触发该函数。
    // 对响应错误做点什么
    return Promise.reject(error);
});

// /** 
//  * get方法，对应get请求 
//  * @param {String} url [请求的url地址] 
//  * @param {Object} params [请求时携带的参数] 
//  */
//  export function get(url, params){    
//     return new Promise((resolve, reject) =>{        
//         axios.get(url, {            
//             params: params        
//         })        
//         .then(res => {            
//             resolve(res.data);        
//         })        
//         .catch(err => {            
//             reject(err.data)        
//         })    
//     });
// }
// /** 
//  * post方法，对应post请求 
//  * @param {String} url [请求的url地址] 
//  * @param {Object} params [请求时携带的参数] 
//  */
// export function post(url, params) {    
//     return new Promise((resolve, reject) => {         
//         axios.post(url, Qs.stringify(params))        
//         .then(res => {            
//             resolve(res.data);        
//         })        
//         .catch(err => {            
//             reject(err.data)        
//         })    
//     });
// }
// 导出
export default request;



// WEBPACK FOOTER //
// ./src/utils/request.js